import React, { useState, useContext } from "react";
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Extratos from '../../Extratos/Extratos';
import Rodape from '../../Rodape/Rodape';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { identificacaoUsuarioLogado } from '../../../utils';
import 'react-toastify/dist/ReactToastify.css';
import { MyContext } from '../../../context/MyContext';

function ExtratosItens() {
  let history = useHistory();
  // const toastMensagemErrorBKPComRedirecionamento = (message) => toast.error(message,{ position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000, onClose: () => { redirecionarPagina(); } });
  // const toastMensagemErrorLoginBKPComRedirecionamento = (message) => toast.error(message,  { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000, onClose: () => { redirecionarPaginaLogin(); } });    
  const toastMensagemError = (message) => toast.error(message, { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000 });
 
  const toastMensagemErrorLogin = (message) => toast.error(message, { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000 });    

  const { destinoPagina, setDestinoPagina } = useContext(MyContext);  
  const [showingToast, setShowingToast] = useState(0);
  const [showingToastNeedLogin, setShowingToastNeedLogin] = useState(1);
  let usuarioComprasFaturado = sessionStorage.getItem("usuario_compras_faturado");
  let usuarioLogado = sessionStorage.getItem("id_loja_usuario");
  if (usuarioLogado != null && usuarioLogado != ""){
    usuarioLogado = identificacaoUsuarioLogado(usuarioLogado);        
  }
  
  const liberado = () => {
    if (usuarioLogado === null || usuarioLogado === "" || usuarioLogado.length === 0)
    {      
      setShowingToastNeedLogin(1);
      needLogin();
      return (
        <div>       
          <Rodape />
        </div>
      )


    }
    else{
      return (
        <div>
          <Extratos />
          <Rodape />
        </div>
      )
    }    
  }

  const redirecionarPagina = () => {
    setShowingToast(0);
    history.push("/");
  }

  const redirecionarPaginaLogin = () => {
    setShowingToast(0);
    history.push("/login");
  }

  const travado = () => {    
    if (showingToast === 0) {
      setShowingToast(1);
      setDestinoPagina("home");
      toastMensagemError("SOMENTE PARA CLIENTES FATURADOS!");      
      history.push("/");
      return;
    }
  }

  const needLogin = () => {
    if (showingToast === 0) {
      setShowingToast(1);
      setDestinoPagina("faturado");
      toastMensagemErrorLogin("NECESSÁRIO EFETUAR LOGIN!");
      history.push("/login");
      return;
    }        
  }

  return (
    <div>
      <NavBarTop />
      <ToastContainer />
      {
        (usuarioLogado != null ?
          (usuarioComprasFaturado == 1 ?
            liberado()
            :
            travado()
          )
          :
          needLogin()
        )}      
    </div>
  )

}
export default ExtratosItens